import { createWebHistory, createRouter } from 'vue-router'

import HomeView from './views/HomeView.vue'

const ProjectView = () => import(/* webpackChunkName: "project" */ './views/ProjectView.vue')
const TrackView = () => import(/* webpackChunkName: "track" */ './views/TrackView.vue')
const AgentView = () => import(/* webpackChunkName: "agent" */ './views/AgentView.vue')
const HelpView = () => import(/* webpackChunkName: "help" */ './views/HelpView.vue')
const LinkView = () => import(/* webpackChunkName: "link" */ './views/LinkView.vue')
const LoginView = () => import(/* webpackChunkName: "login" */ './views/LoginView.vue')
const GoogleCallbackView = () => import(/* webpackChunkName: "login" */ './views/GoogleCallbackView.vue')
const ThanksView = () => import(/* webpackChunkName: "thanks" */ './views/ThanksView.vue')
const SettingsView = () => import(/* webpackChunkName: "settings" */ './views/SettingsView.vue')
const UITest = () => import(/* webpackChunkName: "uitest" */ './views/UITest.vue')
const SubscriptionView = () => import(/* webpackChunkName: "subscription" */ './views/SubscriptionView.vue')

const settingsTab = (tab) => ({ path: '/settings', query: { tab } })

const routes = [
  { path: '/', component: HomeView },
  { path: '/project/:id', component: ProjectView, props: true },
  { path: '/track/:id', component: TrackView, props: true},
  { path: '/account', redirect: settingsTab('account') },
  {
    path: '/agent',
    component: AgentView,
    beforeEnter: (to) => {
      if (to.query.id && to.query.name && to.query.version) return true
      return settingsTab('agents')
    }
  },
  { path: '/agents', redirect: settingsTab('agents') },
  { path: '/help', component: HelpView },
  { path: '/links', redirect: settingsTab('links') },
  { path: '/link/:id', component: LinkView, props: true },
  { path: '/login', component: LoginView },
  { path: '/login/google', component: GoogleCallbackView },
  { path: '/login/apple', component: LoginView },
  { path: '/thanks', component: ThanksView },
  { path: '/settings', component: SettingsView },
  { path: '/uitest', component: UITest },
  { path: '/subscribe', component: SubscriptionView }
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})
